'use client';

import { LoadingProvider } from '@/contexts/LoadingContext';
import { TranslationProvider } from '@/lib/i18n';
import { FrameworkProvider } from '@/providers';

type CoreProvidersProps = {
  children: React.ReactNode;
};

export function CoreProviders({ children }: CoreProvidersProps) {
  return (
    <FrameworkProvider>
      <LoadingProvider>
        <TranslationProvider>{children}</TranslationProvider>
      </LoadingProvider>
    </FrameworkProvider>
  );
}

export default CoreProviders;
